module.exports = __webpack_public_path__ + "static/media/group@3x.0d1212b4.jpg";